// idbRetry.js
// Shared retry-with-reopen helper for IndexedDB resilience on iOS Safari.
// iOS aggressively kills IndexedDB connections when tabs are backgrounded
// or under memory pressure. This wrapper retries once with a fresh
// connection before falling back to a safe default value.

/**
 * Execute an IndexedDB operation with one automatic retry on failure.
 * @param {Function} operation  - async () => result
 * @param {*}        fallback   - value to return if both attempts fail
 * @param {string}   label      - human-readable label for warning logs
 * @param {Function} [reopenFn] - optional async callback invoked between attempts
 * @returns {Promise<*>} operation result, or fallback
 */
export async function withIdbRetry(operation, fallback, label, reopenFn) {
  try {
    return await operation();
  } catch (firstError) {
    console.warn(
      `IndexedDB operation failed (${label}), retrying:`,
      firstError?.message || firstError
    );
    try {
      if (reopenFn) await reopenFn();
      return await operation();
    } catch (retryError) {
      console.warn(
        `IndexedDB retry failed (${label}), using fallback:`,
        retryError?.message || retryError
      );
      return fallback;
    }
  }
}